import images from './images';

const wines = [
  {
    title: 'Acacia',
    price: '$56',
    tags: 'AU | Bottle',
  },
  {
    title: 'Awash',
    price: '$59',
    tags: 'AU | Bottle',
  },
  {
    title: 'Dankira',
    price: '$44',
    tags: 'FR | 750 ml',
  },
  {
    title: 'Gouder',
    price: '$31',
    tags: 'CA | 750 ml',
  },
  {
    title: 'Habesha Tej',
    price: '$26',
    tags: 'IE | 750 ml',
  },
];

const cocktails = [
  {
    title: 'Beyeaynetu',
    price: '$20',
    tags: 'Gomen | Alicha Kik | Kik | Fasting',
  },
  {
    title: 'Doro Wot',
    price: '$16',
    tags: 'Chicken | Eggs | Meet Lovers',
  },
  {
    title: 'Kikil',
    price: '$10',
    tags: 'Lamb |Stew | Meet Lovers',
  },
  {
    title: 'Kitfo',
    price: '$31',
    tags: 'Beef | Filet | Meet Lovers',
  },
  {
    title: 'Tibs',
    price: '$26',
    tags: 'Beef | Smoked Paprika | Awaze | Meet Lovers',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'Authentic',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'AA Hospitality',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Chef',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

export default { wines, cocktails, awards };
